import styled from "styled-components";

interface Props {
  label: string;
  selected: boolean;
  onClick: () => void;
}

const Radio = ({ label, selected, onClick }: Props) => {
  return (
    <StyledRadio>
      {selected ? (
        <StyledImg
          src={require("../../assets/images/radio-selected.png")}
          alt="imag-doc"
          width="18px"
          height="18px"
          onClick={onClick}
        />
      ) : (
        <StyledImg
          src={require("../../assets/images/radio-unselected.png")}
          alt="imag-doc"
          width="18px"
          height="18px"
          onClick={onClick}
        />
      )}
      <span>{label}</span>
    </StyledRadio>
  );
};

const StyledRadio = styled.button`
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  background: transparent;
  gap: 0.5rem;
  font-family:"Poppins-Medium"
`;

const StyledImg = styled.img`
  cursor: pointer;
`;

export default Radio;
